// SHORTCUT: hard-coded renames; ceiling is these three departments, and every further rename needs
// an app release. Upgrade path: rename the departments in MFL and delete this map.
const DISPLAY_NAMES: Record<string, string> = {
  'Cordials & Syrups': 'Cocktail Mixers & Cordials',
  // DIS-2047: the page heading matches the menu label.
  'Light & Non Alcoholic Beer': 'Light & Non-Alcoholic Beer',
  'Premixed Drinks': 'Premixed',
};

/** The display name for an MFL department name, or `name` unchanged. */
// An own-property check: a plain lookup also returns inherited members such as `constructor`.
// Not `Object.hasOwn`: tsconfig `lib` is ES2021, and `hasOwn` is ES2022.
export const departmentDisplayName = (name: string): string =>
  Object.prototype.hasOwnProperty.call(DISPLAY_NAMES, name) ? DISPLAY_NAMES[name] : name;
